import { isNullOrUndefined } from '@bimser/core';
import { findMessage } from '../../BCIntl';

const getExceptionData = (
	exception: any,
	controlKey?: string,
	exceptionCounter: number = 0,
	getLastException: boolean = false
) => {
	if (!exception) {
		return;
	}

	const { InnerException, ExternalException } = exception;
	const innerExceptionExists = !isNullOrUndefined(InnerException);
	const externalExceptionExists = !isNullOrUndefined(ExternalException);
	const controlKeyExists = !isNullOrUndefined(controlKey);

	if (getLastException) {
		if (!controlKeyExists) {
			if (innerExceptionExists) {
				return getExceptionData(InnerException, undefined, undefined, true);
			} else if (externalExceptionExists && ExternalException !== findMessage.get('100526')) {
				return {
					Code: 'EXTERNAL_EXCEPTION',
					Message: ExternalException
				};
			}
		} else if (controlKey === exceptionCounter.toString()) {
			return exception;
		}
	} else {
		if (controlKey === exceptionCounter.toString()) {
			return exception;
		}
		if (innerExceptionExists) {
			return getExceptionData(InnerException, controlKey, exceptionCounter + 1);
		}
		if (externalExceptionExists && ExternalException !== findMessage.get('100526')) {
			return {
				Code: 'EXTERNAL_EXCEPTION',
				Message: ExternalException
			};
		}
	}
};

export { getExceptionData };
